import type { FC, ReactNode } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { TooltipValue } from "app/pages/digital-marketing/generative-ai/llm-tracker/reports/sources-report/domain-influence/domains-map/DomainsMap.styled";

interface ITooltipRowProps {
    name: string;
    value: ReactNode;
}

export const TooltipRow: FC<ITooltipRowProps> = ({ name, value }) => {
    return (
        <Flex
            justifyContent="space-between"
            gap="16px"
        >
            <Text
                fontVariant="subtitle2"
                color={colorsPalettes.carbon[500]}
            >
                {name}
            </Text>
            {["string", "number", "boolean"].includes(typeof value) ? (
                <TooltipValue
                    fontVariant="input2"
                    color={colorsPalettes.carbon[400]}
                >
                    {value}
                </TooltipValue>
            ) : (
                value
            )}
        </Flex>
    );
};
